import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import { EnumTipoEstadoRegistro, EstadoRegistro } from "../../../../utils/enums";
import { getDescriptionEstadoSubsidioMINVU } from "../../../contabilidad/validadorAsientos/utils/utils";
import { InformeSegDesDto } from "../models/informeDesg";
import { format } from "rut.js";


export function useColumns() {

    const COLUMNS: columns<InformeSegDesDto>[] = [
        {
            name: 'Numero operación',
            selector: (row) =>
                row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'RUT cliente',
            selector: (row) => format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Nombre cliente',
            selector: (row) =>
                `${row.nombres} ${row.apellidoPaterno} ${row.apellidoMaterno}`,
            sortable: true,
            sortField: 'nombres',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'N° póliza seguro',
            selector: (row) =>
                row.codigoPoliza,
            sortable: true,
            sortField: 'codigoPoliza',
            wrap: true,
            export: true,
        },
        {
            name: 'Prima (UF)',
            selector: (row) =>
                numericFormatter(row?.prima?.toString() ?? "0", { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'prima',
            wrap: true,
            export: true,
        },
        {
            name: 'Prima (Moneda origen del crédito)',
            selector: (row) =>
                numericFormatter(row?.prima?.toString() ?? "0", { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'prima',
            wrap: true,
            export: true,
        }
    ]

    return { COLUMNS };
}